import React from "react";
import "./Common_Title.css";

const Common_Title = ({ title, subtitle }) => {
  return (
    <div className="common_title">
      <h2 className="title">{title}</h2>
      {subtitle && <p className="subtitle">{subtitle}</p>}
    </div>
  );
};

export default Common_Title;